import { Button, Col, Form, Input, Row, Space, theme, Table, message, Popconfirm } from 'antd';
import React, { useEffect, useState } from 'react';
import LoadingBase from '../../components/LoadingBase';
import '../../css/listbook-page.css';
import { updateShopById, getListDataSku, getListTypeAction, getListAccount, addNewSku, updateSkuInfo, getSkuDetailById, deleteSkuById } from '../../services/apis';
import { consoleLogUtil } from '../../utils/consoleLogUtil';
import ModalDataDesign from './modal/ModalDataSku';
import { TYPE_MODAL } from '../../constants/constants';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';
import { formatNumber } from '../../utils/funcHelper';

const DataSkuPage = () => {
    const { token } = theme.useToken();
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const [total, setTotal] = useState(0);
    const [isShowModal, setIsShowModal] = useState(false);
    const [itemSelected, setItemSelected] = useState(null);
    const [typeModal, setTypeModal] = useState(null);
    const [lstAction, setLstAction] = useState([]);
    const [lstUser, setLstUser] = useState([]);
    const userReducer = useSelector((state) => state.userReducer?.data);
    const columns = [
        {
            title: 'STT',
            key: 'STT',
            width: 80,
            align: 'center',
            render: (text, record, index) => index + 1,
        },
        {
            title: 'Sku code',
            dataIndex: 'sku_code',
            key: 'sku_code',
            render: (text, record, index) => <a style={{ paddingLeft: 12 }} onClick={() => getDataDetailDesign(record?.id)}>{text}</a>,
        },
        {
            title: 'Sku name',
            dataIndex: 'sku_name',
            key: 'sku_name',
            render: (text, record, index) => <div style={{ paddingLeft: 12 }}>{text}</div>,
        },
        {
            title: 'Base cost',
            dataIndex: 'base_cost',
            key: 'base_cost',
            align: 'center',
            render: (text, record, index) => <div>
                <span style={{ paddingLeft: 8, paddingRight: 8 }}>{text ?? 0} $</span>
            </div>,
        },
        {
            title: 'Size',
            dataIndex: 'size',
            key: 'size',
            render: (text, record, index) => <div style={{ paddingLeft: 12 }}>{text}</div>,
        },
        {
            title: 'Color',
            dataIndex: 'color',
            key: 'color',
            align: 'center',
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            align: 'center',
        },
        {
            title: 'Hành động',
            dataIndex: 'action',
            key: 'action',
            width: 120,
            align: 'center',
            render: (text, record) => (
                <Space size="middle">
                    <Popconfirm
                        title="Bạn có chắc chắn muốn xoá không?"
                        onConfirm={() => handleDeleteSku(record)}
                        onCancel={() => consoleLogUtil("cancel")}
                        okText="Có"
                        cancelText="Không"
                    >
                        <a style={{ color: 'red' }}>Xoá</a>
                    </Popconfirm>
                </Space>
            ),
        },
    ];

    const formStyle = {
        maxWidth: 'none',
        background: 'white',
        borderRadius: token.borderRadiusLG,
        paddingLeft: 0,
        paddingRight: 0,
        marginBottom: 12,
    };

    const handleDeleteSku = async (record) => {
        try {
            const params = {
                id: record?.id,
                updated_by: userReducer?.user_info?.id
            };
            setLoading(true);
            const res = await deleteSkuById(params);
            setLoading(false);
            if (res && res?.status === 1) {
                message.success("Xoá sku thành công");
                getDataDesign(true);
            } else {
                message.warning(res?.msg ?? 'Xoá sku thất bại');
            }
        } catch (error) {
            setLoading(false);
            consoleLogUtil("errrrror", error)
        }
    }


    const getDataDesign = async (showLoading, page, limit) => {
        try {
            const params = {
                keyword: form.getFieldValue('keyword') ?? '',
                page: page ?? currentPage,
                limit: limit ?? pageSize
            }
            if (showLoading) setLoading(true);
            const res = await getListDataSku(params);
            if (showLoading) setLoading(false);
            if (res && res.status === 1) {
                setData([...res?.data?.data]);
                setTotal(res?.data?.pagination?.total_rows);
            } else {
                message.error(res.message);
                setData([]);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }


    const getDataDetailDesign = async (id) => {
        try {
            const params = {
                id: id
            }
            setLoading(true);
            const res = await getSkuDetailById(params);
            consoleLogUtil("getListDataDesign", res);
            setLoading(false);
            if (res && res.status === 1) {
                setItemSelected(res?.data);
                setIsShowModal(true);
                setTypeModal(TYPE_MODAL.EDIT);
            } else {
                message.error(res.message);
                setItemSelected(null);
            }
        } catch (error) {
            setLoading(false);
            console.log('error', error);
        }
    }

    const callAPIAddNewSKU = async (data) => {
        consoleLogUtil("callAPIAddNewSKU", data);
        try {
            data.created_by = userReducer?.user_info?.id;
            setLoading(true);
            const res = await addNewSku(data);
            consoleLogUtil("callAPIAddNewSKU", res);
            setLoading(false);
            if (res && res?.status === 1) {
                message.success("Thêm mới thành công");
                getDataDesign(true);
            } else {
                message.warning(res?.msg ?? 'Thêm mới thất bại');
            }
        } catch (error) {
            setLoading(false);
            consoleLogUtil("errrrror", error)
        }
    }
    const callAPIUpdateSKUInfo = async (data) => {
        consoleLogUtil("callAPIUpdateSKUInfo", data);
        try {
            data.updated_by = userReducer?.user_info?.id;
            setLoading(true);
            const res = await updateSkuInfo(data);
            consoleLogUtil("callAPIUpdateSKUInfo", res);
            setLoading(false);
            if (res && res?.status === 1) {
                message.success("Cập nhật thành công");
                getDataDesign(true);
            } else {
                message.warning(res?.msg ?? 'Cập nhật thất bại');
            }
        } catch (error) {
            setLoading(false);
            consoleLogUtil("errrrror", error)
        }
    }
    const handleSaveModal = async (data) => {
        setIsShowModal(false);
        if (typeModal === TYPE_MODAL.ADD) {
            await callAPIAddNewSKU(data);
        } else {
            await callAPIUpdateSKUInfo(data);
        }
    }

    const onFinish = async (dataForm) => {
        getDataDesign(true, 1, pageSize);
        setCurrentPage(1);
    };


    useEffect(() => {
        setLoading(true);
        Promise.all([
            getDataDesign(false, 1, pageSize)
        ]).catch((error) => {
            console.log('error', error);
        }).finally(() => {
            setLoading(false);
        });
    }, [])

    return (
        <div className='container-content'>

            <Form form={form} name="advanced_search" style={formStyle} onFinish={onFinish}>
                <Row gutter={24}>
                    <Col span={8}>
                        <Form.Item
                            name={'keyword'}
                        >
                            <Input placeholder={'Nhập tên'} />
                        </Form.Item>
                    </Col>


                    <Col span={4}>
                        <Space size="small">
                            <Button type="primary" htmlType="submit" icon={<SearchOutlined />} >
                                Tìm kiếm
                            </Button>
                            <Button type="primary" danger icon={<PlusOutlined />} 
                                onClick={() => {
                                    setTypeModal(TYPE_MODAL.ADD);
                                    setIsShowModal(true);
                                } }
                            >
                                Thêm mới
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Form>
            <Table
                className='table-book custom-table'
                columns={columns}
                dataSource={data}
                pagination={{
                    showSizeChanger: true,
                    size: 'small',
                    pageSize: pageSize,
                    total: total,
                    showTotal: (total, range) => `Tổng số ${formatNumber(total)} bản ghi`,
                    showQuickJumper: true,
                    pageSizeOptions: [10, 20, 50, 100],
                    current: currentPage,
                    onChange: (page, pageSize) => {
                        setCurrentPage(page);
                        setPageSize(pageSize);
                        getDataDesign(true, page, pageSize);
                    },
                    onShowSizeChange: (page, pageSize) => {
                        setCurrentPage(page);
                        setPageSize(pageSize);
                        getDataDesign(true, page, pageSize);
                    },
                }}
                rowKey={(record) => record?.id}
                bordered
                rowClassName={() => 'custom-row'}
                scroll={{ x: 1300 }}
            />
            <ModalDataDesign
                visible={isShowModal}
                onCancel={() => setIsShowModal(false)}
                data={itemSelected}
                type={typeModal}
                lstAction={lstAction}
                lstUser={[]}
                onSave={handleSaveModal}
            />
            <LoadingBase loading={loading} />
        </div>
    )
}
export default React.memo(DataSkuPage);